import * as React from 'react';
import SVGInline from 'react-svg-inline';

import LinkButton from '../../Button/LinkButton';
import { ReviewsLocale } from './reviews.locale';

import styles from './Reviews.scss';

import quotesIcon from '../../Icon/quotes.svg';
import jonasMeduna from './jonas-meduna.jpeg';

interface ReviewsProps {
  locale: ReviewsLocale;
}

const Reviews: React.SFC<ReviewsProps> = ({ locale }) => (
  <div className="container">
    <div className="row">
      <div className="col-12 col-lg-6 d-flex flex-column justify-content-center order-1 order-lg-0 mt-6 mt-lg-0">
        <h2 className={styles.title}>{locale.title}</h2>
        <div className={styles.buttonRow}>
          <LinkButton to={locale.contactButton.href} large>
            {locale.contactButton.text}
          </LinkButton>
          <span className={styles.buttonDescription}>- {locale.buttonDescription}</span>
        </div>
      </div>
      <div className="col-12 col-lg-6 d-flex align-items-center order-0 order-lg-1">
        <div className={styles.reviewBox}>
          <p className={styles.reviewText}>“{locale.review}”</p>
          <div className={styles.author}>
            <div className={styles.avatarContainer}>
              <img src={jonasMeduna} alt={locale.author} className={styles.authorName} width={70} />
            </div>
            <div className={styles.authorInfo}>
              <span className={styles.authorName}>{locale.author}</span>
              <span className={styles.authorCompany}>JON.cz</span>
            </div>
          </div>
          <SVGInline svg={quotesIcon} className={styles.quotes} />
        </div>
      </div>
    </div>
  </div>
);

export default Reviews;



// WEBPACK FOOTER //
// /www/client/src/components/HomePage/Reviews/Reviews.tsx